// extracted by mini-css-extract-plugin
export default {"wrap":"Label_wrap__E-sJy","label":"Label_label__xdGXY","value":"Label_value__gdst1"};